import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { Smartphone } from "lucide-react";

export function BuyQr({ price }) {
  const url = `${window.location.origin}/`;
  const short = url.replace(/^https?:\/\//, "").replace(/\/$/, "");
  return (
    <div data-testid="studio-qr" className="flex items-center gap-4 p-4 rounded-2xl bg-white/[0.04] border border-white/10">
      <div className="p-2 rounded-xl bg-white shrink-0">
        <QRCodeSVG value={url} size={96} level="M" bgColor="#FFFFFF" fgColor="#0B0C10" />
      </div>
      <div className="min-w-0">
        <div className="flex items-center gap-1.5 text-xs uppercase tracking-[0.3em] text-[#00F0FF]"><Smartphone className="w-3.5 h-3.5" /> Speel mee</div>
        <div className="mt-1 text-lg font-black leading-tight" style={{ fontFamily: "Unbounded, sans-serif" }}>Scan &amp; koop je kaart</div>
        <div className="mt-1 text-sm text-slate-300 font-mono break-all" data-testid="studio-qr-url">{short}</div>
        {price != null && <div className="mt-1 text-xs text-slate-400">€{Number(price).toFixed(2)} per kaart · iDEAL | Wero of creditcard</div>}
      </div>
    </div>
  );
}
